import Layout from "@/components/Layout";
import PageHeader from "@/components/PageHeader";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { Layers, GitBranch, Database } from "lucide-react";
import ArchitectureOverview from "@/components/architecture/ArchitectureOverview";
import BusinessLogicTab from "@/components/architecture/BusinessLogicTab";
import DataModelTab from "@/components/architecture/DataModelTab";

export default function Architecture() {
  return (
    <Layout>
      <div className="space-y-6 flex-1 flex flex-col min-h-0">
        <PageHeader
          title="Architecture"
          description="Vue d'ensemble de la stack technique, des workflows metier et du modele de donnees."
        />

        <Tabs defaultValue="overview" className="flex-1 flex flex-col min-h-0">
          <TabsList className="w-fit">
            <TabsTrigger value="overview" className="gap-1.5">
              <Layers className="h-4 w-4" />
              Architecture globale
            </TabsTrigger>
            <TabsTrigger value="business" className="gap-1.5">
              <GitBranch className="h-4 w-4" />
              Logique metier
            </TabsTrigger>
            <TabsTrigger value="datamodel" className="gap-1.5">
              <Database className="h-4 w-4" />
              Modele de donnees
            </TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="flex-1 overflow-auto mt-4">
            <ArchitectureOverview />
          </TabsContent>

          <TabsContent value="business" className="flex-1 overflow-auto mt-4">
            <BusinessLogicTab />
          </TabsContent>

          <TabsContent value="datamodel" className="flex-1 overflow-auto mt-4">
            <DataModelTab />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
